import type { Filters, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'

function normalizeCommissionListFilters(filters?: Partial<Filters>): Partial<Filters> | undefined {
  if (!filters) {
    return undefined
  }

  if (filters.filters !== undefined) {
    return filters
  }

  const column = filters.column
  const search = filters.search
  if (column && search !== undefined && search !== '') {
    return {
      filters: [{ id: '0', column, search: String(search) }],
    }
  }

  if (filters.start_date || filters.end_date) {
    return {
      filters: [
        {
          id: '0',
          column: filters.column || 'created_at',
          search: '',
          start_date: filters.start_date,
          end_date: filters.end_date,
        },
      ],
    }
  }

  return undefined
}

export function getCommissionListParamString(filters?: Partial<Filters>, pagination?: Partial<Pagination>): string {
  return getRequestParamString(normalizeCommissionListFilters(filters), pagination)
}
